import React from 'react'
import './contact.css'
import {MdOutlineMail} from 'react-icons/md'
import {RiMessengerLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'

import { useRef } from 'react';
import emailjs from 'emailjs-com'

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_8mkowxe', 'template_7y9x80c', form.current, ' Nt6GJeU6DaHruyOnj')
    e.target.reset()
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2> Contact Me</h2>

      <div className='container contact_container'>
            <div className='contact_options'>
              <article className='contact_option'>
                <MdOutlineMail className='contact_option-icon'/>
                 <h4>Email</h4>
                 <h5>cbimokono@gmail.com</h5>
                 <a href='mailto:cbimokono@gmail.com'>Send a Message</a>
              </article>

              <article className='contact_option'>
                <RiMessengerLine className='contact_option-icon'/>
                 <h4>Facebook</h4>
                 <h5>chrys bim</h5>
                 <a href='https://m.me/chrys.bim' target={"_blank"}>Send a Message</a>
              </article>

              <article className='contact_option'>
                <BsWhatsapp className='contact_option-icon'/>
                 <h4>Whatsapp</h4>
                 <h5>+17135533954</h5>
                 <a href='https://api.whatsapp.com/send?phone=+17315533954' target={"_blank"}>Send a Message</a>
              </article>
            </div>
            <form ref={form} onSubmit={sendEmail}>
              <input type={"text"} name='name' placeholder='Your Full Name' required />
              <input type={"email"} name='email' placeholder='Your Email' required />
              < textarea name='message' rows={"7"} placeholder="Your Message" required ></textarea>
              <button type='submit' className='btn btn-primary'>Send a message</button>
            </form>
      </div>
    </section>
  )
}

export default Contact